import { $el } from 'src/scripts/utils/utils'
import { ModalComponent } from '../../components/modal/modal'

const INPUT_SELECTOR = '[password-modal-input]'

export class PasswordModal extends ModalComponent {
  async show(): Promise<void> {
    super.show()
    $el(INPUT_SELECTOR, this)?.focus()
  }
}
